module.exports = __webpack_public_path__ + "img/avatar2.9e4f4c1f.png";